export default __webpack_public_path__ + "static/switch-light-mode-b7b388bf97cd2efab6c8dee6001cc939.mp4";